module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_has.js
 ** module id = 90
 ** module chunks = 0
 **/